import { Heading, Rule } from '@frontendmentorio/design-system-v2';

import RetrospectivePreview from '../RetrospectivePreview';

export default function Description({ solution }) {
  return (
    <div className="bg-gray-100 container-md flex flex-col gap-4 p-4 rounded-xl">
      <Heading level="5" tagName="h2">
        Solution retrospective
      </Heading>

      <Rule />

      <RetrospectivePreview solution={solution} />
    </div>
  );
}
